import { useEffect, useRef } from 'react';

const FloatingPetals = () => {
  const canvasRef = useRef(null);
  const petalsRef = useRef([]);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const colors = ['#D4AF37', '#8B0000', '#F2E3BC', '#B8860B'];

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resize();
    window.addEventListener('resize', resize);

    // Initialize petals
    const petalCount = 25;
    petalsRef.current = Array.from({ length: petalCount }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height - canvas.height,
      size: Math.random() * 8 + 4,
      speedY: Math.random() * 0.5 + 0.2,
      speedX: Math.random() * 0.3 - 0.15,
      rotation: Math.random() * Math.PI * 2,
      rotationSpeed: Math.random() * 0.02 - 0.01,
      color: colors[Math.floor(Math.random() * colors.length)],
      opacity: Math.random() * 0.5 + 0.3,
      wobble: Math.random() * Math.PI * 2,
      wobbleSpeed: Math.random() * 0.02 + 0.01,
    }));

    const drawPetal = (petal) => {
      ctx.save();
      ctx.translate(petal.x, petal.y);
      ctx.rotate(petal.rotation);
      ctx.globalAlpha = petal.opacity;

      // Draw a simple petal shape
      ctx.beginPath();
      ctx.moveTo(0, -petal.size);
      ctx.bezierCurveTo(
        petal.size * 0.8, -petal.size * 0.5,
        petal.size * 0.8, petal.size * 0.5,
        0, petal.size
      );
      ctx.bezierCurveTo(
        -petal.size * 0.8, petal.size * 0.5,
        -petal.size * 0.8, -petal.size * 0.5,
        0, -petal.size
      );
      ctx.fillStyle = petal.color;
      ctx.fill();

      ctx.restore();
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      petalsRef.current.forEach((petal) => {
        // Update position
        petal.wobble += petal.wobbleSpeed;
        petal.y += petal.speedY;
        petal.x += petal.speedX + Math.sin(petal.wobble) * 0.3;
        petal.rotation += petal.rotationSpeed;

        // Reset if off screen
        if (petal.y > canvas.height + petal.size) {
          petal.y = -petal.size * 2;
          petal.x = Math.random() * canvas.width;
        }
        if (petal.x < -petal.size) {
          petal.x = canvas.width + petal.size;
        }
        if (petal.x > canvas.width + petal.size) {
          petal.x = -petal.size;
        }

        drawPetal(petal);
      });

      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resize);
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="petals-container"
      data-testid="floating-petals-canvas"
    />
  );
};

export default FloatingPetals;
